<template>
    <el-dialog
        title="操作提醒"
        :visible.sync="visible"
        append-to-body
        class="confirm-dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        @close="onClose"
    >
        <!-- 驳回信息校验 -->
        <div v-if="shangguanRejectValidObj.show">
            <div class="xx-h1">
                驳回信息校验
            </div>
            <div>
                {{ shangguanRejectValidObj.tip }}
            </div>
        </div>
        <!-- 后台品类check -->
        <div v-if="categoryValidObj.show">
            <div class="xx-h1">
                后台类目校验
            </div>
            <div>
                {{ categoryValidObj.tip }}
            </div>
        </div>
        <!-- 品牌check -->
        <div v-if="brandValidObj.show">
            <div class="xx-h1">
                品牌校验
            </div>
            <div>
                {{ brandValidObj.tip }}
            </div>
        </div>
        <!-- 条形码实物图check -->
        <div v-if="codeValidObj.show">
            <div class="xx-h1">
                条形码校验
            </div>
            <div>
                {{ codeValidObj.tip }}
            </div>
            <div>
                {{ ocrDescription }}
            </div>
            <div>
                <el-tag
                    v-if="codeValidObj.usedOcrIdentifyResult"
                    size="mini"
                >
                    已使用识别结果
                </el-tag>
                <div v-else>
                    <el-button
                        type="text"
                        @click="useOcrResult('codeValidObj')"
                    >
                        使用识别结果
                    </el-button>
                    <div style="display: flex;">
                        <div style="width: 50px;">
                            说明
                        </div>
                        <el-input
                            v-model="codeValidObj.desc"
                            style="flex: 1;"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- 保质期check -->
        <div v-if="guaranteePeriodValidObj.show">
            <div class="xx-h1">
                保质期校验
            </div>
            <div>
                {{ guaranteePeriodValidObj.tip }}
            </div>
            <div>
                {{ ocrDescription }}
            </div>
            <div>
                <el-tag
                    v-if="guaranteePeriodValidObj.usedOcrIdentifyResult"
                    size="mini"
                >
                    已使用识别结果
                </el-tag>
                <div v-else>
                    <el-button
                        type="text"
                        @click="useOcrResult('guaranteePeriodValidObj')"
                    >
                        使用识别结果
                    </el-button>
                    <div style="display: flex;">
                        <div style="width: 50px;">
                            说明
                        </div>
                        <el-input
                            v-model="guaranteePeriodValidObj.desc"
                            style="flex: 1;"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入内容"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- 实物图 check -->
        <div v-if="physicalPicValidObj.show">
            <div class="xx-h1">
                实物图校验
            </div>
            <div>
                {{ physicalPicValidObj.tip }}
            </div>
        </div>
        <!-- 列表用图 check -->
        <div v-if="lbWhiteBgPicValidObj.show">
            <div class="xx-h1">
                列表用图校验
            </div>
            <div>
                {{ lbWhiteBgPicValidObj.tip }}
            </div>
        </div>
        <!-- 主图 check 1.背标图 2.第一张白底图 -->
        <div v-if="ztPicValidObj.show || ztWhiteBgPicValidObj.show">
            <div class="xx-h1">
                商品主图校验
            </div>
            <div v-if="ztPicValidObj.tip">
                {{ ztPicValidObj.tip }}
            </div>
            <div v-if="ztWhiteBgPicValidObj.tip">
                {{ ztWhiteBgPicValidObj.tip }}
            </div>
        </div>
        <div v-if="ocrEQCDateObj.show">
            <div class="xx-h1">
                入境检疫证明日期校验
            </div>
            <div
                v-for="item in ocrEQCDateObj.tipsList"
                :key="item"
            >
                {{ item }}
            </div>
        </div>
        <div v-if="ocrCDDateObj.show">
            <div class="xx-h1">
                报关单日期校验
            </div>
            <div
                v-for="item in ocrCDDateObj.tipsList"
                :key="item"
            >
                {{ item }}
            </div>
        </div>
        <div v-if="ocrQIRTitleObj.show">
            <div class="xx-h1">
                商品检测报告校验
            </div>
            <div
                v-for="item in ocrQIRTitleObj.tipsList"
                :key="item"
            >
                {{ item }}
            </div>
        </div>
        <div v-if="ocrQIRManufactureObj.show">
            <div class="xx-h1">
                商品检测报告生产商校验
            </div>
            <div
                v-for="item in ocrQIRManufactureObj.tipsList"
                :key="item"
            >
                {{ item }}
            </div>
        </div>
        <div v-if="ocrPPManufactureObj.show">
            <div class="xx-h1">
                生产商校验
            </div>
            <div
                v-for="item in ocrPPManufactureObj.tipsList"
                :key="item"
            >
                {{ item }}
            </div>
        </div>
        <div v-if="ocrPPSMarkObj.show">
            <div class="xx-h1">
                其他资质校验
            </div>
            <div
                v-for="item in ocrPPSMarkObj.tipsList"
                :key="item"
            >
                {{ item }}
            </div>
        </div>
        <span
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                type="primary"
                @click="onContinue"
            >{{ continueText }}</el-button>
            <el-button @click="onClose(true)">{{ cancelText }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
const defaultParams = () => ({
    show: false,
    tip: '',
});

const defaultListParams = () => ({
    show: false,
    tipsList: [],
});

const defaultChangeParams = () => ({
    show: false,
    tip: '',
    ocrIdentifyResult: [],
    usedOcrIdentifyResult: false,
    desc: '',
});

export default {
    name: 'ConfirmDialog',
    components: {
    },
    props: {
        codeValid: {
            type: Boolean,
            default: false,
        },
        brandValid: {
            type: Boolean,
            default: false,
        },
        categoryValid: {
            type: Boolean,
            default: false,
        },
        // 保质期
        guaranteePeriodValid: {
            type: Boolean,
            default: false,
        },
        // 实物图
        physicalPicValid: {
            type: Boolean,
            default: false,
        },
        // 主图
        ztPicValid: {
            type: Boolean,
            default: false,
        },
        // 列表白底图
        lbWhiteBgPicValid: {
            type: Boolean,
            default: false,
        },
        // 主图白底图
        ztWhiteBgPicValid: {
            type: Boolean,
            default: false,
        },
        // 商管驳回信息提示
        shangguanRejectValid: {
            type: Boolean,
            default: false,
        },

        ocrEQCDateValid: {
            type: Boolean,
            default: false,
        },

        ocrCDDateValid: {
            type: Boolean,
            default: false,
        },

        ocrQIRTitleValid: {
            type: Boolean,
            default: false,
        },

        ocrQIRManufactureValid: {
            type: Boolean,
            default: false,
        },

        ocrPPManufactureValid: {
            type: Boolean,
            default: false,
        },

        ocrPPSMarkValid: {
            type: Boolean,
            default: false,
        },


        continueText: {
            type: String,
            default: '确认提交',
        },

        cancelText: {
            type: String,
            default: '取消提交',
        },
    },
    data() {
        return {
            visible: false,
            codeValidObj: defaultChangeParams(),
            brandValidObj: defaultParams(),
            categoryValidObj: defaultParams(),
            guaranteePeriodValidObj: defaultChangeParams(),
            physicalPicValidObj: defaultParams(),
            ztPicValidObj: defaultParams(),
            lbWhiteBgPicValidObj: defaultParams(),
            ztWhiteBgPicValidObj: defaultParams(),
            shangguanRejectValidObj: defaultParams(),
            ocrDescription: '请确认：1、实物图是否正确；2、实物图相关信息是否清晰可见；3、人工输入的内容是否与实物图完全一致；',
            ocrEQCDateObj: defaultListParams(), // OCR入境检疫证明日期
            ocrCDDateObj: defaultListParams(), // OCR报关单日期
            ocrQIRTitleObj: defaultListParams(), // OCR商品检测报告title
            ocrQIRManufactureObj: defaultListParams(), // OCR商品检测报告生产商
            ocrPPManufactureObj: defaultListParams(), // 实物生产商识别
            ocrPPSMarkObj: defaultListParams(), // 特殊标记识别
        };
    },
    methods: {
        onContinue() {
            const ocrDescList = [];
            if (this.guaranteePeriodValidObj.show && this.guaranteePeriodValidObj.usedOcrIdentifyResult === false) {
                if (this.guaranteePeriodValidObj.desc === '') {
                    this.$message.error('请填写保质期填写和识别结果不一致说明');
                    return;
                } else {
                    ocrDescList.push({
                        type: 3, // 保质期
                        desc: this.guaranteePeriodValidObj.desc,
                    });
                }
            }
            if (this.codeValidObj.show && this.codeValidObj.usedOcrIdentifyResult === false) {
                if (this.codeValidObj.desc === '') {
                    this.$message.error('请填写保质期填写和识别结果不一致说明');
                    return;
                } else {
                    ocrDescList.push({
                        type: 4, // 条形码
                        desc: this.codeValidObj.desc,
                    });
                }
            }
            this.$emit('success', ocrDescList);
            this.visible = false;
        },
        onClose(isClickCancelButton = false) {
            /**
             * - 抛出success事件，也会进入onClose方法，此时isClickCancelButton是false
             * - 点击“取消提交”按钮，也会进入onClose方法，此时isClickCancelButton是true
             * - 取消通过关闭按钮、按下ESC和点击modal关闭dialog的方式（便于区分上面两种情况）
             */
            this.$emit('cancel', isClickCancelButton);
            this.reset();
            this.visible = false;
        },
        reset() {
            this.codeValidObj = defaultChangeParams();
            this.brandValidObj = defaultParams();
            this.categoryValidObj = defaultParams();
            this.guaranteePeriodValidObj = defaultChangeParams();
            this.physicalPicValidObj = defaultParams();
            this.ztPicValidObj = defaultParams();
            this.lbWhiteBgPicValidObj = defaultParams();
            this.ztWhiteBgPicValidObj = defaultParams();
            this.shangguanRejectValidObj = defaultParams();
            this.ocrEQCDateObj = defaultListParams(); // OCR入境检疫证明日期
            this.ocrCDDateObj = defaultListParams(); // OCR报关单日期
            this.ocrQIRTitleObj = defaultListParams(); // OCR商品检测报告title
            this.ocrQIRManufactureObj = defaultListParams(); // OCR商品检测报告生产商
            this.ocrPPManufactureObj = defaultListParams(); // 实物生产商识别
            this.ocrPPSMarkObj = defaultListParams(); // 特殊标记识别
        },
        async useOcrResult(type) {
            try {
                if (type === 'codeValidObj') {
                    await this.$confirm('点击后会将改字段值自动更新为识别结果，是否替换？', '提示',
                        {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                        });
                    this.$emit('usedOcrIdentifyResult', {
                        type,
                        ocrIdentifyResult: this[type].ocrIdentifyResult,
                        cb: () => {
                            this[type].usedOcrIdentifyResult = true;
                        },
                    });
                } else {
                    this.$emit('usedOcrIdentifyResult', {
                        type,
                        ocrIdentifyResult: this[type].ocrIdentifyResult,
                        cb: () => {
                            this[type].usedOcrIdentifyResult = true;
                        },
                    });
                }
            } catch (e) {
                this.$message.error(e.message);
            }
        },
        async _popup({ ocrValidParams, preSubmitValidParams }) {
            let flag = false;
            // 扩展其他校验逻辑
            const jobs = [this.getOCRCheckResult(ocrValidParams)];
            if (preSubmitValidParams) jobs.push(this.getPreSubmitCheck(preSubmitValidParams));
            const res = await Promise.all(jobs);

            // OCR校验
            // type "校验字段类型 1:后台品类 2:品牌 3:保质期 4:条形码 5实物图 6主图"
            if (res && res[0] !== 'error') {
                const { ocrValidateResult } = res[0];
                if (!ocrValidateResult) return;

                const {
                    codeValid,
                    brandValid,
                    categoryValid,
                    guaranteePeriodValid,
                    physicalPicValid,
                    ztPicValid,
                    lbWhiteBgPicValid,
                    ztWhiteBgPicValid,
                    ocrEQCDateValid,
                    ocrCDDateValid,
                    ocrQIRTitleValid,
                    ocrQIRManufactureValid,
                    ocrPPManufactureValid,
                    ocrPPSMarkValid,
                    ocrEQCDateObj,
                    ocrCDDateObj,
                    ocrQIRTitleObj,
                    ocrQIRManufactureObj,
                    ocrPPManufactureObj,
                    ocrPPSMarkObj,
                } = this;

                let code = {};
                let brand = {};
                let category = {};
                let guaranteePeriod = {};
                let phsical = null;
                let zt = {};
                let lbWhiteBgPic = {};
                let ztWhiteBgPic = {};

                ocrValidateResult.forEach((item) => {
                    if (item.type === 1) category = item;
                    if (item.type === 2) brand = item;
                    if (item.type === 3) guaranteePeriod = item;
                    if (item.type === 4) code = item;
                    if (item.type === 5) {
                        if (phsical) {
                            phsical.message += `${phsical.message ? '；' : ''}${item.message}`;
                        } else {
                            phsical = item;
                        }
                    }
                    if (item.type === 6) zt = item;
                    if (item.type === 7) lbWhiteBgPic = item; // 列表白底图
                    if (item.type === 8) ztWhiteBgPic = item; // 主图白底图

                    if (item.type === 9 && item.message) ocrEQCDateObj.tipsList.push(item.message);
                    if (item.type === 10 && item.message) ocrCDDateObj.tipsList.push(item.message);
                    if (item.type === 11 && item.message) ocrQIRTitleObj.tipsList.push(item.message);
                    if (item.type === 12 && item.message) ocrQIRManufactureObj.tipsList.push(item.message);
                    if (item.type === 13 && item.message) ocrPPManufactureObj.tipsList.push(item.message);
                    if (item.type === 14 && item.message) ocrPPSMarkObj.tipsList.push(item.message);
                });

                if (ocrEQCDateValid && ocrEQCDateObj.tipsList.length) {
                    ocrEQCDateObj.show = true;
                    this.visible = true;
                    flag = true;
                }

                if (ocrCDDateValid && ocrCDDateObj.tipsList.length) {
                    ocrCDDateObj.show = true;
                    this.visible = true;
                    flag = true;
                }

                if (ocrQIRTitleValid && ocrQIRTitleObj.tipsList.length) {
                    ocrQIRTitleObj.show = true;
                    this.visible = true;
                    flag = true;
                }

                if (ocrQIRManufactureValid && ocrQIRManufactureObj.tipsList.length) {
                    ocrQIRManufactureObj.show = true;
                    this.visible = true;
                    flag = true;
                }

                if (ocrPPManufactureValid && ocrPPManufactureObj.tipsList.length) {
                    ocrPPManufactureObj.show = true;
                    this.visible = true;
                    flag = true;
                }

                if (ocrPPSMarkValid && ocrPPSMarkObj.tipsList.length) {
                    ocrPPSMarkObj.show = true;
                    this.visible = true;
                    flag = true;
                }

                if (categoryValid && category.message) {
                    this.categoryValidObj.show = true;
                    this.categoryValidObj.tip = category.message;
                    this.visible = true;
                    flag = true;
                }

                if (brandValid && brand.message) {
                    this.brandValidObj.show = true;
                    this.brandValidObj.tip = brand.message;
                    this.visible = true;
                    flag = true;
                }

                if (codeValid && code.message) {
                    this.codeValidObj.show = true;
                    this.codeValidObj.tip = code.message;
                    this.codeValidObj.ocrIdentifyResult = code.ocrIdentifyResult;
                    this.visible = true;
                    flag = true;
                }

                if (guaranteePeriodValid && guaranteePeriod.message) {
                    this.guaranteePeriodValidObj.show = true;
                    this.guaranteePeriodValidObj.tip = guaranteePeriod.message;
                    this.guaranteePeriodValidObj.ocrIdentifyResult = guaranteePeriod.ocrIdentifyResult;
                    this.visible = true;
                    flag = true;
                }

                if (physicalPicValid && phsical && phsical.message) {
                    this.physicalPicValidObj.show = true;
                    this.physicalPicValidObj.tip = phsical.message;
                    this.visible = true;
                    flag = true;
                }

                if (ztPicValid && zt.message) {
                    this.ztPicValidObj.show = true;
                    this.ztPicValidObj.tip = zt.message;
                    this.visible = true;
                    flag = true;
                }

                if (lbWhiteBgPicValid && lbWhiteBgPic && lbWhiteBgPic.message) {
                    this.lbWhiteBgPicValidObj.show = true;
                    this.lbWhiteBgPicValidObj.tip = lbWhiteBgPic.message;
                    this.visible = true;
                    flag = true;
                }

                if (ztWhiteBgPicValid && ztWhiteBgPic && ztWhiteBgPic.message) {
                    this.ztWhiteBgPicValidObj.show = true;
                    this.ztWhiteBgPicValidObj.tip = ztWhiteBgPic.message;
                    this.visible = true;
                    flag = true;
                }
            }

            // 处理预提交校验信息
            if (res && res[1] && res[1] !== 'error') {
                const { verifyMessages } = res[1];
                if (!verifyMessages) return;
                const {
                    shangguanRejectValid,
                } = this;

                let shangguanReject = null;

                verifyMessages.forEach((item) => {
                    if (item.type === 1) shangguanReject = item;
                });

                if (shangguanRejectValid && shangguanReject && shangguanReject.message) {
                    this.shangguanRejectValidObj.show = true;
                    this.shangguanRejectValidObj.tip = shangguanReject.message;
                    this.visible = true;
                    flag = true;
                }
            }
            if (!flag) {
                this.$emit('success');
            }
        },
        getOCRCheckResult(params) {
            return this.$service.validCodeByPhysicalPictures({
                // scene - 实物图信息核对场景 1供应商建品 2采购上新编辑提交 3上新详情页审核 4商品基础属性详情页修改提交 5商品基础属性修改详情页审核 6采购商品内容信息编辑 7供应商商品内容信息编辑 8商品内容信息审核 9上新品控审核 10城市保质期编辑 11城市保质期审核 12 供应商建品保存草稿 13 采购建品保存草稿
                scene: params.scene,
                skuId: params.skuId,
                applyId: params.applyId,
                skuCodeList: params.skuCodeList,
                approvalTaskNodeName: params.approvalTaskNodeName,
                bgCategoryId: params.bgCategoryId,
                brandId: params.brandId,
                guaranteePeriod: params.guaranteePeriod,
                ztPictureList: params.ztPictureList,
                lbPicture: params.lbPicture,
            }).catch(() => 'error');
        },

        getPreSubmitCheck(params) {
            return this.$service.getPreSubmitCheck({
                applyId: params.applyId,
            }).catch(() => 'error');
        },
    },
};
</script>

<style lang="scss">
.confirm-dialog {
    .el-dialog__body {
        padding: 0px 20px 20px;
    }
}
</style>
